export const ITEM_LEDGER_PAGE_LIMIT = 100;

export function itemLedgerRequestParams({ scope = "global", cursor = null } = {}) {
  return {
    location_scope: scope || "global",
    limit: ITEM_LEDGER_PAGE_LIMIT,
    ...(cursor ? { cursor } : {}),
  };
}

function movementRowKey(row) {
  return String(row?.id ?? row?.movement_id ?? "");
}

function appendUniqueRows(currentRows = [], nextRows = []) {
  const seen = new Set(currentRows.map(movementRowKey).filter(Boolean));
  return [
    ...currentRows,
    ...nextRows.filter((row) => {
      const key = movementRowKey(row);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    }),
  ];
}

export function mergeItemLedgerPage(current, incoming, { append = false } = {}) {
  if (!append || !current) return incoming;
  const currentScope = current?.pagination?.scope || "global";
  const incomingScope = incoming?.pagination?.scope || "global";
  if (currentScope !== incomingScope) return incoming;

  if (incomingScope === "global") {
    return {
      ...incoming,
      movements: appendUniqueRows(current.movements, incoming.movements),
    };
  }

  return {
    ...incoming,
    location_ledger: {
      ...(incoming.location_ledger || {}),
      entries: appendUniqueRows(
        current?.location_ledger?.entries,
        incoming?.location_ledger?.entries
      ),
    },
  };
}
